module.exports = __webpack_public_path__ + "assets/img/wallet-icon2-s.ebbe07e1.png";